import { NgModule } from 'ng-metadata/core';
import { SearchVaccinationsComponent } from 'common/directory/vaccinations/search-vaccinations.component';

@NgModule({
  declarations: [
    SearchVaccinationsComponent
  ],
})
export class SearchVaccinationsModule {}


// WEBPACK FOOTER //
// ./resources/assets/js/common/directory/vaccinations/search-vaccinations.module.ts